module.exports = __webpack_public_path__ + "img/forget.e59e6ccb.png";